import { sanitizedStringEquals } from "@recharge";

import { ChildProduct, ParentProduct, ProductTitle } from "../types/products";

/** @returns the given string converted to a ProductTitle or undefined if it's not a known ProductTitle */
export function normalizeProductTitle(
  toNormalize: string,
): ProductTitle | undefined {
  const withoutExtraRechargeStuff = toNormalize
    .replace(/\s*\(Ships every \d+ Days?\)\s*/gi, "");
  return Object.values(ProductTitle)
    .find((pt) => sanitizedStringEquals(withoutExtraRechargeStuff, pt, true));
}

/** Helper function that checks that a ProductTitle is a parent product */
export function isMainProduct(
  toCheck: ProductTitle,
): toCheck is ParentProduct {
  switch (toCheck) {
    case ProductTitle.KatKinFreshMealPlan:
    case ProductTitle.AddOnPlan: {
      // This piece of code is completely unnecessary at runtime, it's just here to make sure that the
      // value is of the correct type at compile time and that the compiler doesn't emit an unused var warning
      const parent: ParentProduct = toCheck;
      if (!parent) throw Error(`Empty parent '${parent}', Should never happen`);
      return true;
    }
    case ProductTitle.HealthScoop:
    case ProductTitle.PlanetScoop:
    case ProductTitle.NibblesChicken:
    case ProductTitle.NibblesSalmon:
    case ProductTitle.Sprinkles:
    case ProductTitle.DPDDeliveryFee:
    case ProductTitle.Cluck:
    case ProductTitle.Gobble:
    case ProductTitle.Quack:
    case ProductTitle.Oink:
    case ProductTitle.Splash:
    case ProductTitle.Baaa:
    case ProductTitle.Mooo:
    case ProductTitle.BubbleAndQuack:
    case ProductTitle.PouchChicken:
    case ProductTitle.PouchTurkey:
    case ProductTitle.PouchBeef:
    case ProductTitle.PouchDuck:
    case ProductTitle.Cluck2404:
    case ProductTitle.Gobble2404:
    case ProductTitle.Quack2404:
    case ProductTitle.Oink2404:
    case ProductTitle.Splash2404:
    case ProductTitle.Baaa2404:
    case ProductTitle.Mooo2404: {
      // See above comment about why this exists
      const child: ChildProduct = toCheck;
      if (!child) throw Error(`Empty child '${child}', Should never happen`);
      return false;
    }
    default: {
      const never: never = toCheck;
      throw Error(`Unexpected ProductTitle '${never}' in ${isMainProduct.name}`);
    }
  }
}
